import React, { useContext, useState } from 'react';
import { Button } from 'edozvola-frontend-lib/dist/ui';
import PreviousDocumentsAddForm from 'app/edozvola/cases/previous-documents/previous-documents-add-form';
import PreviousDocumentsTable from 'app/edozvola/cases/previous-documents/previous-documents-table';
import { CaseTabContext } from 'app/edozvola/cases/case-form-wrapper';
import { getCaseContext } from 'app/shared/util/context-util';

const PreviousDocuments = () => {
  const [previousDocument, setPreviousDocument] = useState<string | null>(null);
  const { sidebarItemPair } = getCaseContext();

  return (
    <>
      <h6 className={'form-header'}>Akti koji prethode zahtjevu</h6>
      <div className={'d-flex justify-content-between flex-row-reverse'}>
        {!sidebarItemPair?.readOnly && (
          <Button label="Dodaj akt" color="info" size="lg" prependIcon={'plus'} onClick={() => setPreviousDocument('')} />
        )}
      </div>
      <div className={'mt-3'}>
        <PreviousDocumentsTable onRowClick={(idCasePreviousDocumentMap: string) => setPreviousDocument(idCasePreviousDocumentMap)} />
      </div>
      {previousDocument !== null && (
        <PreviousDocumentsAddForm onCloseCallback={() => setPreviousDocument(null)} idCasePreviousDocumentMap={previousDocument} />
      )}
    </>
  );
};

export default PreviousDocuments;
